import StoreModuleService from '../StoreModuleService';
import { initialState } from './state';
import Vue from 'vue';

// mutations declarations
export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_FEATURE_FLAGS](state, value) {
		Vue.set(state, 'data', value);
		Vue.set(state, 'flagsAreLoaded', true);
	},
};

export default mutations;
